export default __webpack_public_path__ + "static/media/next.5a2b0b77.svg";